// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { gsap, ScrollTrigger } from "gsap/all";
import { useTranslation } from "/utils/hooks/useCustomTranslation";

import FunticoLogo from "/components/core/Logo";
import UnLoginedButton from "/components/core/HeaderNavButtons";
import { useContext } from "react";
import AuthContext from "/context/AuthProvider";
import DelayLink from "/components/core/DelayLink";
import Wallet from "/assets/img/icons/wallet.svg";

import UserAvatar from "/components/core/UserAvatar";
import CustomButton from "/components/core/ButtonDefault";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";
import { useWithdrawableBalance } from "/api/user/tico-balance";
import { BalanceTooltipContent } from "../core/BalanceTooltipContent";
import { usePopper } from "react-popper";
import Aside from "./Aside";
import { useAnimation } from "/context/AnimationProvider";
import { funticoUrl } from "/utils/links";

gsap.registerPlugin(ScrollTrigger);

const CashierWidget = ({ state, isMobile }) => {
  const { t } = useTranslation();
  const props = {
    title: isMobile ? null : t("layout.header.deposit"),
    onClick: () => state.setShowWallet(true),
    classname: "pr wallet",
  };

  return (
    <CustomButton {...{ ...props, def: isMobile ? 24 : 40 }}>
      {isMobile ? <Wallet /> : null}
    </CustomButton>
  );
};

const domain = import.meta.env.VITE_REACT_COOKIE_DOMAIN;

const logos = [
  {
    img: "/logo-game.png",
    link: `${window.location.protocol}//gameloop${domain}`,
  },
  { img: "/logo-funtico.svg", link: `${funticoUrl}/` },
];

export default function Header({ state }) {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const pathname = window.location.pathname;
  const isProfile = pathname.includes("profile");
  const s = state.getState();
  const showNavigation = s.showNavigation;
  const popup = s.opened_popup;
  const axiosClient = useAxiosWithAuth();
  const { data: balanceResponse } = useWithdrawableBalance(axiosClient);
  const [openNavBar, setOpenNavBar] = useState(false);
  const { isMobile, setAllowPlay } = useAnimation();
  const [isSelecting, setIsSelecting] = useState(false);

  useEffect(() => {
    const onClick = (e) => {
      if (!e.target.closest(".selecting")) {
        setIsSelecting(false);
      }
    };

    isSelecting &&
      setTimeout(() => {
        document.addEventListener("click", onClick);
      }, 100);
    return () => {
      document.removeEventListener("click", onClick);
    };
  }, [isSelecting]);

  const scrollToTop = () => {
    if (window.scrollToSection) {
      window.scrollToSection(0);
    } else {
      gsap.to(window, {
        scrollTo: {
          y: 0,
        },
        duration: 0.5,
      });
    }
  };

  useEffect(() => {
    popup.open && setOpenNavBar(false);
    return () => {};
  }, [popup.open]);

  useEffect(() => {
    document.body.classList.toggle("logined", auth.token);

    return () => {};
  }, [auth.token]);

  return (
    <>
      <div className="header_wrapper">
        <header className="header">
          <div
            className={`list-logos df ai-c fantico_logo ${isSelecting ? "active" : ""}`}
          >
            <div className="logos">
              <div className="select-logo df" onClick={scrollToTop}>
                <img src={"/logo-sports.png"} alt="Sports" />
              </div>
              {!isMobile && isSelecting && (
                <>
                  <div className="selecting df fd-c">
                    {logos.map((logo, i) => (
                      <a
                        href={logo.link}
                        className="df select-logo"
                        key={i}
                        onClick={(e) => {
                          e.preventDefault();
                          setIsSelecting(false);
                          setTimeout(() => {
                            window.open(logo.link, "_self");
                          }, 100);
                        }}
                      >
                        <img src={logo.img} alt="" />
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>

            {!isMobile &&
              (isSelecting ? (
                <>
                  <button
                    className="close close_icon icon-24"
                    onClick={() => setIsSelecting(false)}
                  ></button>
                </>
              ) : (
                <button className="select" onClick={() => setIsSelecting(true)}>
                  <span>SWITCH</span>
                  <div className="mask_switch icon_16"></div>
                </button>
              ))}
          </div>
          {showNavigation &&
            (!isMobile ? (
              <UnLoginedButton state={state} auth={auth}>
                <CashierWidget {...{ state, isMobile }} />
              </UnLoginedButton>
            ) : (
              <>
                <button
                  className="mobile_open br-16 def grey"
                  onClick={() => setOpenNavBar(true)}
                >
                  <div className="b df fd-c jc-c">
                    <span></span>
                    <span></span>
                  </div>
                </button>

                {auth.token ? (
                  isProfile ? (
                    <a href={"/profile"} title={t("layout.header.profile")}>
                      <UserAvatar {...auth}>
                        {/* <div className="info"></div> */}
                      </UserAvatar>
                    </a>
                  ) : (
                    <DelayLink
                      to={`${funticoUrl}/profile`}
                      title={t("layout.header.profile")}
                    >
                      <UserAvatar {...auth}>
                        {/* <div className="info"></div> */}
                      </UserAvatar>
                    </DelayLink>
                  )
                ) : null}
              </>
            ))}
        </header>
        {/* {showNavigation && */}
        {isMobile &&
          (auth?.token ? (
            <div className="fixed_ballance df jc-sb ai-c">
              <div className="space_taker">{/* Just to not update css */}</div>
              <div className="df fd-c ai-c">
                <div className="bal df ai-c">
                  <div className="tico_icon ico" />
                  {balanceResponse?.balance}
                </div>
                <Tooltip>
                  <BalanceTooltipContent balanceResponse={balanceResponse} />
                </Tooltip>
              </div>
              <CashierWidget {...{ state, isMobile }} />
            </div>
          ) : (
            <div className="fixed_login">
              <UnLoginedButton state={state} auth={auth}></UnLoginedButton>
            </div>
          ))}
      </div>

      <div className="background-kivi" data-kivi>
        <div className="back">{/* <img src={kivi} /> */}</div>
        <div className="paralax car-6"></div>
        <div className="paralax car-5"></div>
        <div className="paralax car-4"></div>
        <div className="paralax car-3"></div>
        <div className="paralax car-2"></div>
        <div className="paralax car-1"></div>
        <div className="paralax glare"></div>

        <div className="balls">
          <div className="b b-1"></div>
          <div className="b b-2"></div>
          <div className="b b-3"></div>
          <div className="b b-4"></div>
          <div className="b b-5"></div>
        </div>

        <div className="fixed-intro">
          <div className="logo">
            <div className="logo-back"></div>
            <div className="logo-front"></div>
          </div>

          <div className="scroll-down">
            <button
              className="cta kanit-bold"
              data-scroll
              data-text={isMobile ? "TAP TO START" : "CLICK TO START"}
            >
              {isMobile ? "TAP TO START" : "CLICK TO START"}
            </button>
          </div>
        </div>
      </div>

      {isMobile && (
        <Aside
          state={state}
          openNav={setOpenNavBar}
          isOpen={openNavBar}
          logos={logos}
        />
      )}
    </>
  );
}

// TODO: Extract and refactor this component to be used in other places
/**
 * A tooltip component that displays content in a floating popup
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to display inside the tooltip
 * @param {string} [props.placement="bottom" | "top" | "left" | "right"] - Preferred placement of tooltip relative to trigger element
 * @returns {JSX.Element} Tooltip component
 */
export function Tooltip({ children }) {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement] = useState(null);
  const [isHidden, setIsHidden] = useState(true);

  const { styles, attributes, update } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: "top",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
        {
          name: "flip",
          options: {
            fallbackPlacements: ["bottom", "right", "left"],
            boundary: "clippingParents",
            padding: 8,
          },
        },
        {
          name: "preventOverflow",
          options: {
            boundary: "clippingParents",
            padding: 8,
            altAxis: true,
          },
        },
        {
          name: "computeStyles",
          options: {
            gpuAcceleration: true,
            adaptive: false,
          },
        },
        {
          name: "arrow",
          options: {
            padding: 5,
            element: arrowElement,
          },
        },
        {
          name: "hide",
          enabled: true,
        },
      ],
    }
  );

  const handleHide = useCallback(() => {
    setIsHidden(true);
  }, [setIsHidden]);

  const handleClick = useCallback(() => {
    setIsHidden((prev) => !prev);
  }, [setIsHidden]);

  useEffect(() => {
    if (popperElement) {
      popperElement.setAttribute("data-popper-reference-hidden", isHidden);
      update?.();
    }
  }, [popperElement, update, isHidden]);

  useEffect(() => {
    setIsHidden(true);
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="balance_details_trigger fixel_14 df jc-l mr-t-4"
        ref={setReferenceElement}
        onClick={handleClick}
      >
        details
      </button>
      <div
        className="info_message"
        ref={setPopperElement}
        style={{
          ...styles.popper,
          ...(isHidden ? { display: "none" } : {}),
        }}
        {...attributes.popper}
      >
        <div className="wrapper br-8">
          <button
            type="button"
            className="close_icon close_tooltip"
            onClick={handleHide}
          />
          {children}
        </div>
      </div>
    </div>
  );
}
